import axios from 'axios';
import api from '../constants/api';
import { HEADERS } from '../constants/headers';

/**
 * Uploads a file to AWS S3
 *
 * @param {*} file
 * @param {*} fileName
 */
export const uploadFileToAWS = async (file, path, fileName) => {
    const image = await api.post(
        `/uploads/publicImage`,
        {
            type: file.type,
            fileName,
            path
        },
        HEADERS()
    );

    await axios.put(image.data.url, file, {
        headers: { 'Content-Type': file ? file.type : null },
    });

    const response = `https://automotive-api.s3.us-east-2.amazonaws.com/${image.data.key}`;

    return response;
};
